import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus, Edit, Trash2 } from 'lucide-react';
import api from '../api';
import Pagination from '../components/Pagination';

import { FILE_BASE_URL } from '../constants';

const resolveImageSrc = (value) => {
    if (!value) return '';
    if (value.startsWith('http')) return value;
    return `${FILE_BASE_URL}${value}`;
};

const TrainingManagement = () => {
    const navigate = useNavigate();
    const [trainings, setTrainings] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [totalPages, setTotalPages] = useState(0);
    const [totalElements, setTotalElements] = useState(0);

    useEffect(() => {
        fetchTrainings();
    }, [currentPage, pageSize]);

    const fetchTrainings = async () => {
        try {
            setLoading(true);
            const response = await api.get('/trainings', {
                params: {
                    page: currentPage,
                    size: pageSize
                }
            });
            setTrainings(response.data.content);
            setTotalPages(response.data.totalPages);
            setTotalElements(response.data.totalElements);
        } catch (error) {
            console.error("Error fetching trainings:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm('Bạn có chắc chắn muốn xóa khóa học này?')) {
            try {
                await api.delete(`/trainings/${id}`);
                fetchTrainings();
            } catch (error) {
                console.error("Error deleting training:", error);
            }
        }
    };

    return (
        <div className="training-management">
            <div className="filters-bar" style={{ justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', gap: '16px' }}>
                    <input
                        type="text"
                        placeholder="Tìm kiếm khóa học"
                        className="search-input"
                        style={{ width: '300px' }}
                    />
                </div>
                <button className="btn-primary" onClick={() => navigate('/training/create')}>
                    <Plus size={18} /> Thêm bài viết mới
                </button>
            </div>

            <div className="data-table-container">
                {loading ? (
                    <div>Loading...</div>
                ) : (
                    <table className="data-table">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Hình ảnh</th>
                                <th>Tiêu đề</th>
                                <th>Hành động</th>
                            </tr>
                        </thead>
                        <tbody>
                            {trainings.map((course) => {
                                const imageSrc = resolveImageSrc(course.image);
                                return (
                                    <tr key={course.id}>
                                        <td>{course.id}</td>
                                        <td>
                                            {imageSrc ? (
                                                <img
                                                    src={imageSrc}
                                                    alt={course.title}
                                                    style={{ width: '60px', height: '40px', objectFit: 'cover', borderRadius: '4px' }}
                                                />
                                            ) : (
                                                <div style={{ width: '60px', height: '40px', background: '#F0F0F0', borderRadius: '4px' }} />
                                            )}
                                        </td>
                                        <td>
                                            <div style={{ fontWeight: 500, maxWidth: '300px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                {course.title}
                                            </div>
                                            <div style={{ fontSize: '12px', color: '#666', maxWidth: '300px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                {course.description}
                                            </div>
                                        </td>
                                        <td>
                                            <div style={{ display: 'flex', gap: '8px' }}>
                                                <button
                                                    onClick={() => navigate(`/training/${course.id}`)}
                                                    style={{ border: 'none', background: 'none', cursor: 'pointer', color: '#0068FF' }}
                                                >
                                                    <Edit size={18} />
                                                </button>
                                                <button
                                                    onClick={() => handleDelete(course.id)}
                                                    style={{ border: 'none', background: 'none', cursor: 'pointer', color: '#D32F2F' }}
                                                >
                                                    <Trash2 size={18} />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                )}
                <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    totalElements={totalElements}
                    pageSize={pageSize}
                    onPageChange={setCurrentPage}
                    onPageSizeChange={(size) => {
                        setPageSize(size);
                        setCurrentPage(0);
                    }}
                />
            </div>
        </div>
    );
};

export default TrainingManagement;
